import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { backend, producturl } from "../../../../path";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import LoaderMain from "../../../layout/header/loader_sub";
import ScrollToTop from "../../../components/whatsapp connect";
import { Rating } from "@mui/material";
import styled, { keyframes } from "styled-components";
function WishList(props) {
  const navigate = useNavigate();
  const [isFilter, setIsFilter] = useState(false);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [priceBounds, setPriceBounds] = useState({ min: 0, max: 10000 });

  const favouriteCount = fullData?.length ?? 0;
  const uniqueCategories = new Set(
    fullData.map((item) => item?.category_name).filter(Boolean)
  ).size;
  const totalValue = fullData.reduce((sum, item) => {
    const amount = Number(item?.mrp) || 0;
    return sum + amount;
  }, 0);

  const handleAddToWishList = async (id) => {
    try {
      const response = await fetch(
        backend + `deletewishlistbyiduserside/${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${authenticated?.access_token}`,
          },
        }
      );

      if (response.status === 200) {
        fetchData();
        toast.success("Item removed from wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const fetchData = () => {
    setLoading(true);
    setError(null);

    fetch(backend + `getwishlistbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setFullData(data);
        // Assuming data is an array of products
        setFilteredData(data);
        if (data.length) {
          const prices = data.map((item) => Number(item?.mrp) || 0);
          const min = Math.min(...prices);
          const max = Math.max(...prices);
          setPriceBounds({
            min: Math.max(0, Math.floor(min / 50) * 50),
            max: Math.ceil(Math.max(max, 1000) / 50) * 50,
          });
          setPriceRange([
            Math.max(0, Math.floor(min / 50) * 50),
            Math.ceil(Math.max(max, 1000) / 50) * 50,
          ]);
        } else {
          setPriceBounds({ min: 0, max: 10000 });
          setPriceRange([0, 10000]);
        }
        setCurrentPage(1);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFilter = () => {
    setIsFilter((prevIsFilter) => !prevIsFilter);
  };
  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handlePriceChange = (value) => {
    setPriceRange(value);
  };

  useEffect(() => {
    const filtered = fullData.filter((item) => {
      const amount = Number(item?.mrp) || 0;
      return amount >= priceRange[0] && amount <= priceRange[1];
    });
    setFilteredData(filtered);
  }, [fullData, priceRange]);

  useEffect(() => {
    const totalPages = Math.max(
      Math.ceil(filteredData.length / productsPerPage),
      1
    );
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
      return;
    }
    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    // Assuming data is an array of products
    const products = filteredData.slice(startIndex, endIndex);
    setData(products);
  }, [filteredData, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [priceRange]);

  const totalPages = Math.max(
    Math.ceil(filteredData.length / productsPerPage),
    1
  );

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate(`/login`);
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <main>
        <PageWrapper>
          <HeroSection>
            <BreadcrumbTrail>
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Wishlist</span>
            </BreadcrumbTrail>
            <HeroContent>
              <HeroBadge>Wishlist</HeroBadge>
              <HeroTitle>Your curated favourites</HeroTitle>
              <HeroSubtitle>
                Keep track of the products you love, compare details, and move
                them to your cart whenever you are ready.
              </HeroSubtitle>
              <HeroStats>
                <StatCard>
                  <StatLabel>Total items</StatLabel>
                  <StatValue>{fullData?.length}</StatValue>
                </StatCard>
                <StatCard>
                  <StatLabel>Categories explored</StatLabel>
                  <StatValue>{uniqueCategories}</StatValue>
                </StatCard>
                <StatCard>
                  <StatLabel>Wishlist value</StatLabel>
                  <StatValue>
                    ₹ {totalValue.toLocaleString("en-IN")}
                  </StatValue>
                </StatCard>
              </HeroStats>
            </HeroContent>
          </HeroSection>

          <ContentSection>
            <ControlsRow>
              <CollectionInfo>
                You have <strong>{filteredData.length}</strong> items saved in
                your favourites!
              </CollectionInfo>
              <ControlsGroup>
                <FilterToggle onClick={handleFilter} $active={isFilter}>
                  <i className="fi-rs-settings-sliders mr-5"></i>
                  Filters
                </FilterToggle>
              </ControlsGroup>
            </ControlsRow>

            {isFilter && (
              <FilterPanel>
                <FilterHeader>
                  <FilterTitle>Price range</FilterTitle>
                  <PriceRange>
                    ₹ {priceRange[0].toLocaleString("en-IN")} – ₹
                    {" "}
                    {priceRange[1].toLocaleString("en-IN")}
                  </PriceRange>
                </FilterHeader>
                <Slider
                  range
                  min={priceBounds.min}
                  max={priceBounds.max}
                  value={priceRange}
                  onChange={handlePriceChange}
                  allowCross={false}
                  trackStyle={[{ backgroundColor: "#62bc01" }]}
                  handleStyle={[
                    { backgroundColor: "#62bc01", borderColor: "#62bc01" },
                    { backgroundColor: "#62bc01", borderColor: "#62bc01" }
                  ]}
                  railStyle={{ backgroundColor: "#e5e7eb" }}
                />
              </FilterPanel>
            )}

            {loading ? (
              <LoadingState>
                {/* Loading...  */}
                <LoaderMain />
              </LoadingState>
            ) : error ? (
              <ErrorState>
                <ErrorTitle>We couldn&apos;t load your wishlist.</ErrorTitle>
                <ErrorMessage>{error.message}</ErrorMessage>
              </ErrorState>
            ) : filteredData.length === 0 ? (
              <EmptyState>
                <EmptyBadge>Wishlist</EmptyBadge>
                <EmptyTitle>Your wishlist is waiting</EmptyTitle>
                <EmptySubtitle>
                  Browse our collections and add products you love to see them
                  listed here.
                </EmptySubtitle>
                <EmptyActions>
                  <PrimaryButton onClick={() => navigate("/")}>
                    Discover products
                  </PrimaryButton>
                </EmptyActions>
              </EmptyState>
            ) : (
              <>
                <WishlistGrid>
                  {data.map((item) => (
                    <WishlistCard key={item.wishlist_id || item.product_id}>
                      <CardMedia>
                        <ProductImage
                          onClick={() =>
                            handleProductRoute(item.product_slug)
                          }
                          src={
                            item.thumbnail2
                              ? producturl + item.thumbnail2
                              : producturl + item.thumbnail
                          }
                          alt={item?.product_name ?? "Wishlist product"}
                        />
                        <CardOverlay>
                          <ActionButton
                            aria-label="Quick View"
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            <i className="fi-rs-eye"></i>
                          </ActionButton>
                          <ActionButton
                            aria-label="Remove From Wishlist"
                            onClick={() =>
                              handleAddToWishList(item.wishlist_id)
                            }
                          >
                            <i className="fi-rs-cross-circle"></i>
                          </ActionButton>
                          {/* <a
                          aria-label="Add To Compare"
                          onClick={() => handleProductRoute(item.product_id)}
                          className="action-btn hover-up js-add-to-compare-button"
                        >
                          <i className="fi-rs-shuffle"></i>
                        </a> */}
                        </CardOverlay>
                      </CardMedia>

                      <ProductBottom>
                        <ProductCategory
                          onClick={() =>
                            handleProductRoute(item.product_slug)
                          }
                        >
                          {item?.category_name}
                        </ProductCategory>
                        <ProductName
                          onClick={() =>
                            handleProductRoute(item.product_slug)
                          }
                          title="Nestle Original Coffee-Mate Coffee Creamer"
                        >
                          {item?.product_name}
                        </ProductName>
                        <RatingRow>
                          <Rating
                            name="read-only"
                            value={item?.average_stars}
                            readOnly
                            size="small"
                          />
                          <RatingText>
                            ({item?.average_stars ?? "Not Yet Rated"})
                          </RatingText>
                        </RatingRow>
                        <VendorText>
                          Sold By{" "}
                          <span
                            onClick={() =>
                              handleProductRoute(item.product_slug)
                            }
                          >
                            {item?.manufacturer_name ?? "KeralaSpecial"}
                          </span>
                        </VendorText>
                        <CardFooter>
                          <PriceTag>
                            ₹ {Number(item.mrp).toLocaleString("en-IN")}
                          </PriceTag>
                          <PrimaryButton
                            aria-label="Add To Cart"
                            onClick={() => handleAddCart(item.product_id)}
                          >
                            <i className="fi-rs-shopping-cart mr-5"></i>
                            <span className="d-inline-block">Add</span>
                          </PrimaryButton>
                        </CardFooter>
                      </ProductBottom>
                    </WishlistCard>
                  ))}
                </WishlistGrid>

                {/* Pagination controls */}
                <PaginationBar>
                  <PaginationButton
                    type="button"
                    onClick={() =>
                      setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    Previous
                  </PaginationButton>
                  <PaginationMeta>
                    Page {currentPage} of {totalPages}
                  </PaginationMeta>
                  <PaginationButton
                    type="button"
                    onClick={() =>
                      setCurrentPage((prevPage) => prevPage + 1)
                    }
                    disabled={currentPage >= totalPages ||
                      data.length < productsPerPage}
                  >
                    Next
                  </PaginationButton>
                </PaginationBar>
              </>
            )}
          </ContentSection>
          <ScrollToTop />
        </PageWrapper>
      </main>
    </>
  );
}
export default WishList;
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 40px 24px 120px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media screen and (max-width: 768px) {
    padding: 32px 18px 80px;
  }
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #fff9f0 0%, #ffffff 70%);
  border-radius: 32px;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 40px 90px rgba(15, 23, 42, 0.08);
  animation: ${fadeInScale} 0.6s ease forwards;

  @media screen and (max-width: 768px) {
    border-radius: 24px;
    padding: 36px 28px;
  }
`;

const BreadcrumbTrail = styled.nav`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #6b7280;

  a {
    color: inherit;
    font-weight: 500;
  }

  span:last-child {
    color: #111827;
    font-weight: 600;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: ${fadeInUp} 0.7s ease forwards;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(98, 188, 1, 0.16);
  color: #276221;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 600;
`;

const HeroTitle = styled.h1`
  margin: 0;
  font-size: 42px;
  line-height: 1.1;
  color: #0f172a;

  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
`;

const HeroSubtitle = styled.p`
  margin: 0;
  color: #374151;
  font-size: 16px;
  line-height: 1.7;
  max-width: 620px;
`;

const HeroStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
`;

const StatCard = styled.div`
  min-width: 160px;
  background: #ffffff;
  border-radius: 16px;
  padding: 18px 22px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StatLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const StatValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
`;

const ContentSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const ControlsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

const CollectionInfo = styled.p`
  margin: 0;
  font-size: 15px;
  color: #4b5563;

  strong {
    color: #111827;
  }
`;

const ControlsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FilterToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? "#62bc01" : "#d1d5db")};
  background: ${({ $active }) => ($active ? "rgba(98, 188, 1, 0.12)" : "#fff")};
  color: ${({ $active }) => ($active ? "#255121" : "#1f2937")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  i {
    font-size: 16px;
  }

  &:hover {
    border-color: #62bc01;
    background: rgba(98, 188, 1, 0.12);
    color: #255121;
  }
`;

const FilterPanel = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FilterTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`;

const PriceRange = styled.span`
  font-size: 14px;
  color: #4b5563;
`;

const LoadingState = styled.div`
  padding: 80px 0;
  display: flex;
  justify-content: center;
`;

const ErrorState = styled.div`
  background: rgba(248, 113, 113, 0.1);
  border-radius: 20px;
  padding: 36px;
  text-align: center;
  color: #b91c1c;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ErrorTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const ErrorMessage = styled.p`
  margin: 0;
  font-size: 14px;
`;

const EmptyState = styled.div`
  background: #ffffff;
  border-radius: 28px;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  text-align: center;
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.08);
`;

const EmptyBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(98, 188, 1, 0.12);
  color: #255121;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 1.4px;
`;

const EmptyTitle = styled.h2`
  margin: 0;
  font-size: 30px;
  color: #111827;
`;

const EmptySubtitle = styled.p`
  margin: 0;
  color: #4b5563;
  max-width: 420px;
  line-height: 1.6;
`;

const EmptyActions = styled.div`
  display: flex;
  gap: 12px;
`;

const WishlistGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
`;

const WishlistCard = styled.article`
  background: #ffffff;
  border-radius: 26px;
  box-shadow: 0 32px 70px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 40px 80px rgba(15, 23, 42, 0.08);
  }
`;

const CardMedia = styled.div`
  position: relative;
  padding-top: 68%;
  overflow: hidden;
`;

const ProductImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ActionButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: rgba(17, 24, 39, 0.72);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(98, 188, 1, 0.9);
  }

  i {
    font-size: 18px;
  }
`;

const ProductBottom = styled.div`
  padding: 24px 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #fff;
`;

const ProductCategory = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 600;
  color: #62bc01;
  cursor: pointer;
  width: fit-content;
`;

const ProductName = styled.h2`
  text-wrap: auto;
  margin: 0;
  min-height: 50px;
  font-weight: 600;
  font-size: 22px;
  color: #0f172a;
  cursor: pointer;
`;

const RatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RatingText = styled.span`
  font-size: 13px;
  color: #6b7280;
`;

const VendorText = styled.span`
  font-size: 13px;
  color: #94a3b8;

  span {
    color: #1f2937;
    font-weight: 600;
    cursor: pointer;
  }
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PriceTag = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
`;

const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: #62bc01;
  color: #ffffff;
  border: none;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #4d9800;
  }
`;

const PaginationBar = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const PaginationButton = styled.button`
  padding: 10px 20px;
  border-radius: 999px;
  border: none;
  background: #111827;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:disabled {
    background: #d1d5db;
    color: #6b7280;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #62bc01;
  }
`;

const PaginationMeta = styled.span`
  font-size: 14px;
  color: #4b5563;
`;